import React, { useState } from 'react'
import './NotePreview.scss'

const  NotePreview = (props) => {

/* Manage style of card when delete mode is active */
let cardClassDefault = "card-body note-preview"
let cardClassDelete = "card-body note-preview-delete"
let cardStyle = {
    backgroundColor: props.note.data.color
}
let [cardClass, setCardClass] = useState(cardClassDefault)


    const handleClick = () => {
        if(props.deleteMode){
            toggleCardClass()
        }else{
            props.onClick(props.note)
        }        
    }
    /* When deleteMode is active, toggle card preview to show if it is set for deletion */
    const toggleCardClass = () => {
        if (props.checkDeleteList(props.id)){
            setCardClass(cardClassDefault)
        }else{
            setCardClass(cardClassDelete)
        }
    }

    


    return (
        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12" style={props.style}>
            <div className="card mb-3">
                <div className={cardClass} style={cardStyle} index={props.index} onClick={handleClick}>
                    <h5 className="card-title">{props.note.data.title}</h5>
                    <p className="card-note-text">{props.note.data.text}</p>
                </div>
            </div>
        </div>  

        

    )
}

export default NotePreview